import { render } from "./BankSettings.vue?vue&type=template&id=2ab8fa8c&ts=true"
import script from "./BankSettings.vue?vue&type=script&lang=ts"
export * from "./BankSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__